import { cloneDeep } from 'lodash';

export default function(data, inputs) {
  const newData = cloneDeep(data);

  for (const key in inputs) {
    if (inputs[key]?.disabled) delete newData[key];
  }

  return newData;
}
